import React from 'react';
import './App.css';
import AppRouter from './components/AppRouter'
import AppFooter from './components/AppFooter';

function App() {
    return (
        <div>
            <AppRouter/>
            <AppFooter />
        </div>
    );
}

export default App;